import { Space, Typography } from '../../atoms'

export type AttributeAltProps = {
  label: string
  value: string
}

const AttributeAlt = ({ label, value }: AttributeAltProps) => (
  <Space isflex flexDirection="row">
    <Space pr={1}>
      <Typography variant="b3">{label}:</Typography>
    </Space>
    <Typography variant="sh3">{value}</Typography>
  </Space>
)

export default AttributeAlt
